import React from "react";
import Person from "assets/images/png/person.png";
import { Ticket } from "pages/tickets/ticket.service";
import {formatDate} from "helpers/data";
import Owner from "assets/images/svg/ticket_owner.svg";
import { useTranslation } from "react-i18next";
interface TicketCardProps {
  ticket: Partial<Ticket>;
  selected?: boolean;
  onSelect?: () => void;
}

const TicketCardComponent = ({ ticket, selected = false, onSelect }: TicketCardProps) => {
  const { t } = useTranslation("tickets");

  return (
    <div className={`ticket-box ${selected ? "active" : ""}`} onClick={onSelect}>
      <div className="box-header">
        <h1>{ticket.title}</h1>
        <span className="status">{ticket.status}</span>
      </div>
      <p className="content">{ticket.description?.slice(0, 60)}...</p>
      <hr className="hr" />
      <div className="box-footer">
        <div className="info">
          <img className="pic" src={Owner} alt="person" />
          <span className="name">{ticket.agent?.name}</span>
        </div>
        <div className="time">
          <span> {t("updateOn")} {formatDate(ticket.updateDate!)}</span>
        </div>
      </div>
    </div>
  );
};
export default TicketCardComponent;
